import isEmpty from 'lodash/isEmpty';
import { arrayOf } from 'prop-types';
import React from 'react';
import { Card, Col, Row } from 'reactstrap';

import { creativeShape } from '../../../prop-types';
import CreativeCardImage from '../../CreativeCardImage';

function IncompatibleCreatives({ creatives }) {
  if (isEmpty(creatives)) return null;

  return (
    <Row className="d-flex flex-row flex-wrap">
      {creatives.map(cr => (
        <Col key={cr.id} xs="2" xl="1" className="mb-2">
          <Card>
            <CreativeCardImage creative={cr} />
          </Card>
        </Col>
      ))}
    </Row>
  );
}

IncompatibleCreatives.propTypes = {
  creatives: arrayOf(creativeShape.isRequired),
};

IncompatibleCreatives.defaultProps = {
  creatives: [],
};

export default IncompatibleCreatives;
